import * as React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { AutoCompleteField, AutoComplete, RemoteAutoCompleteField } from '@components/form';

import { Loader } from '@components/loader';
import { createRecord } from '@modules/records/_recordsActions';
import { withNotifications } from '@components/hoc/withNotifications';
import { required } from '@utils/validators';
import { recordCase } from './_eventsEnums';

const enhance = compose<any, any>(
  withState('loader', 'setLoader', false),
  reduxForm({
    form: 'module-events-record-record-create'
  }),
  withNotifications({ createRecord }),
  withHandlers({
    createRecordHandler: ({
      setLoader,
      createRecordNotify,
      eventId,
      closeItem,
      setState,
      onRefresh
    }) => async formData => {
      setLoader(true);
      formData = {
        ...formData,
        eventId
      };
      const response = await createRecordNotify(formData);
      // update record in local state
      setState({ record: response });
      onRefresh();
      setLoader(false);
      closeItem();
    }
  })
);

const View: React.SFC<any> = ({ handleSubmit, createRecordHandler, closeItem, documents, loader, sps }) => {
  return (
    <div>
      {loader && <Loader />}
      <form className="layout" onSubmit={handleSubmit(createRecordHandler)}>
        <Grid fluid={true}>
          <h4>Nový spis</h4>
          <Row>
            <Col md={6}>
              <AutoCompleteField
                component={AutoComplete}
                name="documentId"
                label="Inicializační dokument *"
                items={documents}
                labelFunction={({ documentId }) => documentId}
                valueFunction={({ id }) => id}
                fullWidth={true}
                validate={required}
              />
            </Col>
            {sps === 'geosps' && (
              <Col md={6}>
                <RemoteAutoCompleteField {...recordCase} />
              </Col>
            )}
          </Row>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
        </Grid>

        <Divider />

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </form>
    </div>
  );
};

export const EventsFormRecordServicesRecordCreate = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormRecordServicesRecordCreate.tsx